import { render, staticRenderFns } from "./FormDetail2.vue?vue&type=template&id=ef7bb4a0&scoped=true"
import script from "./FormDetail2.vue?vue&type=script&lang=js"
export * from "./FormDetail2.vue?vue&type=script&lang=js"
import style0 from "./FormDetail2.vue?vue&type=style&index=0&id=ef7bb4a0&prod&scoped=true&lang=css"
import style1 from "./FormDetail2.vue?vue&type=style&index=1&id=ef7bb4a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7bb4a0",
  null
  
)

export default component.exports